import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchLoginFailure } from "../../../../../controller/redux/login-reducers";
import { Link } from "react-router-dom";
import * as cmFun from "common/ulti/commonFunction";
import {
  APP_NAME,
  HOME_PAGE,
  SSO_TYPE,
  VNEID_LOGOUT_URL,
} from "../../../../../config";
import { SSO_AUTH_SIGNOUT } from "controller/api";
import * as ccFun from "common/ulti/cookieFunction";
import { AUTHORIZATION_COOKIE, __DEV__ } from "common/ulti/constants";
import { useNavigate } from "react-router-dom";
import { Badge, Card } from "antd";
import moment from "moment";
import { authSignOut } from "controller/services/authServices";
import "./Header.scss";

const Header = () => {
  const LoginRes = useSelector((state) => state.LoginRes);
  const Profile = useSelector((state) => state.Profile);
  const General = useSelector((state) => state.General);
  const ShowUC = General?.ShowUC || false;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [scrolled, setScrolled] = useState(false);
  const [needToChangePassword, setNeedToChangePassword] = useState(false);

  useEffect(() => {
    if (
      !Profile?.changePassword?.changed ||
      isWithin90Days(Profile?.changePassword?.time || 0)
    ) {
      setNeedToChangePassword(true);
    }
  }, [Profile]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isWithin90Days = (timestamp) => {
    // Chuyển timestamp sang đối tượng moment
    const inputDate = moment(timestamp);

    // Ngày hiện tại
    const now = moment();

    // Tính số ngày chênh lệch
    const diffDays = now.diff(inputDate, "days");

    // Nếu nhỏ hơn hoặc bằng 90 ngày => true
    return diffDays >= 90;
  };

  const handleLogout = async () => {
    // await authSignOut();
    // await ccFun.deleteCookie(AUTHORIZATION_COOKIE);
    // dispatch(fetchLoginFailure({}));
    if (LoginRes?.id_token) {
      await ccFun.deleteCookie(AUTHORIZATION_COOKIE);
      window.location.href = `${SSO_AUTH_SIGNOUT}?type=${SSO_TYPE}&idtoken=${LoginRes.id_token}`;
    } else if (LoginRes?.user?.loaitaikhoan === "VNEID") {
      await ccFun.deleteCookie(AUTHORIZATION_COOKIE);
      window.location.href = `${VNEID_LOGOUT_URL}`;
    } else {
      await authSignOut();
      await ccFun.deleteCookie(AUTHORIZATION_COOKIE);
      dispatch(fetchLoginFailure({}));
    }
  };

  let name = "xxx-xxx-xxx";
  let title = "yyy-yyy-yyy";

  if (!cmFun.isEmpty(LoginRes) || !cmFun.isEmpty(Profile)) {
    name = Profile?.HoVaTen
      ? `${Profile?.HoVaTen?.Ho} ${Profile?.HoVaTen?.ChuDem} ${Profile?.HoVaTen?.Ten}`
      : LoginRes?.user?.email ||
        LoginRes?.user?.sub ||
        LoginRes?.user?.identity;
    title = Profile?.NoiOHienTai?.ChiTiet;
  }
  if (!name || name === "xxx-xxx-xxx") {
    name = LoginRes?.user?.name || name;
    title = LoginRes?.user?.sodinhdanh || title;
  }

  return (
    <nav
      className={
        "nav-header-top navbar navbar-expand bg-dark " +
        (scrolled ? "scrolled" : "")
      }
    >
      {/* <img
        src={require("common/assets/imgs/BG.png")}
        alt="header"
        className="img-header"
      /> */}
      <div className="container-fluid px-4 px-md-5 d-flex align-items-center justify-content-between">
        {/* Logo + App Name — always left */}
        <div className="d-flex align-items-center" style={{ gap: 10 }}>
          <img
            onClick={() => navigate("/home")}
            style={{ cursor: "pointer" }}
            src={require("common/assets/imgs/logo.png")}
            alt="logo"
            className="logo-default"
          />
          <span
            title={APP_NAME.toUpperCase()}
            className="navbar-brand"
            style={{ cursor: "pointer", marginBottom: 0 }}
            onClick={() => navigate("/home")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                navigate("/home");
              }
            }}
          >
            {APP_NAME.toUpperCase()}
          </span>
        </div>

        {/* Right side: user dropdown */}
        <ul className="navbar-nav ml-md-0 mb-0">
          <li className="nav-item dropdown">
            <button
              type="button"
              className="nav-link dropdown-toggle d-flex align-items-center"
              id="userDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              <div className="d-flex flex-column align-items-start align-items-lg-end text-end mr-1">
                <span className="font-weight-bold">
                  {name}&nbsp;
                  {needToChangePassword ? (
                    <Badge
                      dot
                      color="red"
                      style={{ transform: "translateY(-3px)" }}
                    />
                  ) : null}
                </span>
                <span className="font-italic">{title}</span>
              </div>
              <i className="fa fa-user-circle fa-3x header-right-icon-color"></i>
            </button>
            <div
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="userDropdown"
            >
              {/* <Link to="/ca-nhan" className="dropdown-item">
              Cá nhân
            </Link> */}
              {/* <Link to="/mat-khau" className="dropdown-item">
              Đổi mật khẩu
            </Link> */}
              <Link to="/thong-bao-hub" className="dropdown-item">
                Thông báo
              </Link>
              {/* <Link to="/mat-khau" className="dropdown-item">
                Đổi mật khẩu&nbsp;
                {needToChangePassword ? (
                  <Badge
                    dot
                    color="red"
                    style={{ transform: "translateY(-3px)" }}
                  />
                ) : null}
              </Link> */}
              <div className="dropdown-divider"></div>
              <Link to="/ca-nhan" className="dropdown-item">
                Thông tin cá nhân
              </Link>
              {ShowUC && (
                <Link to="/kho-giay-to" className="dropdown-item">
                  Kho giấy tờ
                </Link>
              )}
              <div className="dropdown-divider"></div>
              {ShowUC && (
                <Link to="/phan-anh" className="dropdown-item">
                  Gửi phản ánh
                </Link>
              )}
              <div className="dropdown-divider"></div>

              <button onClick={handleLogout} className="dropdown-item">
                Đăng xuất
              </button>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;
